/**
 * Frontend JavaScript for Icon List Block
 */

document.addEventListener("DOMContentLoaded", function () {
	const iconLists = document.querySelectorAll(".mr-icon-list");

	iconLists.forEach((iconList) => {
		initializeIconList(iconList);
	});

	function initializeIconList(iconList) {
		// Apply dynamic styles based on data attributes
		const hideLabels = iconList.getAttribute("data-hide-labels") === "true";
		const hasDivider = iconList.getAttribute("data-has-divider") === "true";

		if (hideLabels) {
			iconList.classList.add("mr-icon-list--hide-labels");
		}

		if (hasDivider) {
			iconList.classList.add("mr-icon-list--has-divider");
		}

		// Handle responsive alignment
		handleResponsiveAlignment(iconList);
	}

	function handleResponsiveAlignment(iconList) {
		// This function can be extended to handle responsive alignment
		// based on tablet and mobile settings if needed
		const style = getComputedStyle(iconList);
		const alignment = style.getPropertyValue("--mr-icon-list-align");

		if (alignment) {
			iconList.style.textAlign = alignment;
		}
	}

	// Handle dynamic icon loading if Font Awesome is used
	function loadFontAwesome() {
		if (
			!document.querySelector('link[href*="font-awesome"]') &&
			!document.querySelector('link[href*="fontawesome"]')
		) {
			// Only load if not already present
			const link = document.createElement("link");
			link.rel = "stylesheet";
			link.href =
				"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css";
			document.head.appendChild(link);
		}
	}

	// Check if any icon list uses Font Awesome
	const usesFontAwesome = Array.from(iconLists).some((list) => {
		const items = list.querySelectorAll(".mr-icon-list-item");
		return Array.from(items).some((item) => {
			const icon = item.querySelector("i[class*='fa']");
			return icon !== null;
		});
	});

	if (usesFontAwesome) {
		loadFontAwesome();
	}
});
